import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { createRoot } from 'react-dom/client';
import './styles.css';
import reportWebVitals from './reportWebVitals';
import Home from "./pages/Home.js";
import CreateAccount from "./pages/CreateAccount.js";
import Login from "./pages/Login.tsx";
import Logout from "./pages/Logout.js";
import Leaderboard from "./pages/Leaderboard.js";
import Play from "./pages/Play.js";
import Practice from "./pages/Practice.js";
import RegularGame from "./pages/gamemodes/RegularGame.tsx"
import GameOver from "./pages/GameOver.js"

import { initializeApp } from "firebase/app";
import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import { DynamoDBDocumentClient } from "@aws-sdk/lib-dynamodb";

const container = document.getElementById('root');
const root = createRoot(container);

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCDXCDb0rnAnCjSKR2SCqBmkNy05qE0424",
  authDomain: "authentication-e6a67.firebaseapp.com",
  projectId: "authentication-e6a67",
  storageBucket: "authentication-e6a67.firebasestorage.app",
  messagingSenderId: "1070632481083",
  appId: "1:1070632481083:web:25356fc3765277cd83071e"
};

initializeApp(firebaseConfig)

const client = new DynamoDBClient({
  region: "us-west-2",
  credentials: {
    accessKeyId: "AKIAQGYBP7ZIT44WWAOW",
    secretAccessKey: "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"
  }
});

export const docClient = DynamoDBDocumentClient.from(client);

root.render(
  <Router>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/createaccount" element={<CreateAccount />} />
      <Route path="/play" element={<Play />} />
      <Route path="/practice" element={<Practice />} />
      <Route path="/play/regular/:gamemode" element={<RegularGame />} />
      <Route path="/leaderboard" element={<Leaderboard />} />
      <Route path="/gameover" element={<GameOver />} />
      {/* Define other routes here */}
    </Routes>
  </Router>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
